import React from 'react'

import { useListHeaderContext } from 'features/views/ListView/ListHeader/useListHeaderContext'

import { Button } from 'ui/components/Button'

import { AdvancedFilterControl } from './AdvancedFiltersFilterControl'

type ListHeaderAdvancedFilterControlProps = React.ComponentPropsWithoutRef<typeof Button> & {
    isActive?: boolean
}

export const ListHeaderAdvancedFilterControl: React.FC<ListHeaderAdvancedFilterControlProps> = (
    props
) => {
    const { inlineFilters } = useListHeaderContext()
    const filterCount = inlineFilters.length

    return <AdvancedFilterControl {...props} filterCount={filterCount} />
}
